<template>
  <div class="mechanism-container">
    <div class="block-title">基金会简介</div>

    <div class="desc">
      我们的宗旨是：积极践行社会责任，用心传播爱的力量。
      <br />
      北京长安投资公益基金会（以下简称“基金会”）是2017年7月11日经北京市民政局批准成立的慈善组织，原始基金数额为3000万元人民币，来自北京长安投资集团有限公司的全额捐赠。北京长安投资公益基金会自成立三年来慈善活动支出累计为人民币12,788,257.40元 ，捐赠区域涉及内蒙古、湖北、安徽、河北、北京等多个省市自治区，受益人群覆盖20386人次村庄儿童、32名大学生、451名村庄老人、10212人次疫情一线工作人员，并持续资助荒漠植被恢复、环境污染防治、珍稀物种救助等环保项目。
    </div>

    <div class="img-block" style="margin-bottom: 20px;">
      <img src="~@/assets/jj1.png" alt="">
    </div>
    <div class="img-block">
      <img src="~@/assets/jj2.jpg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  created() {

  }
}
</script>

<style lang="scss">
.mechanism-container {
  font-size: 17px;
  

  .desc {
    line-height: 33px;
    // font-size: 14px;
    font-weight: normal;
    color: #0A1121;
    // line-height: 24px;
    margin-bottom: 22px;
  }

  .img-block {
    img {
      width: 100%;
      display: block;
    }
  }
}
</style>
